import { lazy, useEffect } from 'react';
import Index from "./jsx";
import { connect, useDispatch } from 'react-redux';
import {  Route, Routes, useLocation , useNavigate , useParams } from 'react-router-dom';
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
import { useRandomTokenRefresh  } from './util/useAutoRefreshToken';
import loginbg from "./images/bg-login.jpg";
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
const Login = lazy(() => {
    return new Promise(resolve => {
    setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
	
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

function App (props) {
    const dispatch = useDispatch();
	  const navigate = useNavigate();
    useRandomTokenRefresh ()
    useEffect(() => {
       checkAutoLogin(dispatch, navigate);
    }, [dispatch, navigate]);

    let routeblog = (         
      <Routes>
        <Route path='/login' element={<Login />} />
      </Routes> 
    );
    if (props.isAuthenticated) {
		  return (
        <Index /> 
      );
	  }
    else{
      return (
        <div className="min-vh-100 main-bg-image" style={{backgroundImage:"url("+ loginbg +")"}}>
            {routeblog}
        </div>
      );
    }
};


const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App)); 